<template>
  <div class="product-wrap">
    <div class="pc">
      <div class="tab-btn__box">
        <!-- 제품 탭 세팅 - Seq 기반 세팅 -->
        <div class="prod-title">
          <strong>{{ this.$props.companyLabel }}</strong>  소개
        </div>
        <div
          class="btn-inner"
          v-for="(item, index) in this.companyItems"
          :key="index"
          @click="setActiveTab(item?.itemSeq)"
        >
          <button :class="{ on: activeTab === item.itemSeq }">
            {{ item?.itemName || "" }}
          </button>
        </div>
      </div>
    </div>
    <template v-for="(item, index) in this.companyItems" :key="index">
      <div class="tab-box" v-if="activeTab === item.itemSeq">
        <div class="layout__box">
          <!-- 상품이미지 세팅 -->
          <div
            class="img__box"
            v-for="(image, index) in item.itemImagePath"
            :key="index"
          >
            <img
              :src="image"
              alt=""
              @error="this.replaceByDefault($event, 'product')"
            />
          </div>
          <div class="img__box" v-if="item.itemImagePath.length === 0">
            <img
              src="@/assets/images/empty.png"
              alt=""
              @error="this.replaceByDefault($event, 'product')"
            />
          </div>

          <!-- 회사 로고 세팅 -->
          <div class="txt__box">
            <div class="mobile">
              <div class="prod-title">
                  <strong>{{ this.$props.companyLabel  }}</strong>  소개
                </div>
              <div class="tab-btn__box">
                <!-- 제품 탭 세팅 - Seq 기반 세팅 -->
                
                <div
                  class="btn-inner"
                  v-for="(item, index) in this.companyItems"
                  :key="index"
                  @click="setActiveTab(item?.itemSeq)"
                >
                  <button :class="{ on: activeTab === item.itemSeq }">
                    {{ item?.itemName || "" }}
                  </button>
                </div>
              </div>
            </div>
            <div
              class="pd-logo"
              v-if="this.companyLogoImage && this.companyLogoImage !== ''"
            >
              <img
                :src="this.companyLogoImage"
                alt=""
                @error="this.replaceByDefault($event, 'logo')"
              />
            </div>
            <div
              class="pd-logo"
              v-if="!this.companyLogoImage || this.companyLogoImage === ''"
            >
              <img
                src="@/assets/images/empty-logo.svg"
                alt=""
                @error="this.replaceByDefault($event, 'logo')"
              />
            </div>
            <!-- 회사소개 세팅 -->
            <dl
              v-if="this.companyContent && this.companyContent.length > 0"
              class="bd-none"
            >
              <dt>회사소개</dt>
              <dd v-for="(payload, index) in this.companyContent" :key="index">
                - {{ payload.content || "" }}
              </dd>
            </dl>
            <!-- 제품설명 세팅 -->
            <dl v-if="item.itemContents && item.itemContents.length > 0">
              <dt>제품설명</dt>
              <dd v-for="(payload, index) in item.itemContentInfo" :key="index">
                - {{ payload.content || "" }}
              </dd>
              <!-- 통신지원범위 세팅 -->
              <dd
                v-for="(payload, index) in item.itemContentNetworkScope"
                :key="index"
              >
                - 통신지원범위 : {{ payload.content || "" }}
              </dd>
            </dl>
            <!-- 적용범위 세팅 -->
            <dl
              v-if="item.itemContentScope && item.itemContentScope.length > 0"
            >
              <dt>적용범위</dt>
              <dd
                v-for="(payload, index) in item.itemContentScope"
                :key="index"
              >
                - {{ payload.content || "" }}
              </dd>
            </dl>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { defineComponent, ref } from "vue";
import axios from "axios";
import {
  DEF_EMPTY_LOGO_IMG_PATH,
  DEF_EMPTY_PRD_IMG_PATH,
  resolveAssetPath,
} from "@/consts/consts";

// url 공통화
const instance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
});

export default defineComponent({
  name: "ProductIntroduce",
  setup: function () {
    const tabs = []; // 탭 버튼의 내용
    const activeTab = ref(""); // 현재 선택된 탭의 상태를 저장

    function setActiveTab(tab) {
      activeTab.value = tab;
    }

    return {
      tabs,
      activeTab,
      setActiveTab,
    };
  },
  data() {
    return {
      companyItems: [],
      companyName: "",
      companyContent: [],
      companyLogoImage: "",
      companyLocale: "",
    };
  },
  props: {
    id: Number,
    companyLabel : {
      type : String,
      default : "",
      require : false,
    },
  },
  methods: {
    /*
      onerror 대체 이미지 함수
     */
    replaceByDefault(e, type) {
      if (type === "logo") e.target.src = DEF_EMPTY_LOGO_IMG_PATH;
      if (type === "product") e.target.src = DEF_EMPTY_PRD_IMG_PATH;
    },
    getProdictInfo() {
      instance
        .get(`/api/tech/v1.0/company/${this.id}`, {
          headers: {
            "x-api-key": `${process.env.VUE_APP_API_KEY || "YsD4oLqC2MgBzP1x"}`, // 여기에 API 키 값을 넣어주세요
          },
        })
        .then((res) => {
          if (res.data.code === "200") {
            const items = res.data.results.items;
            const payload = res.data.results;

            /* 회사 */
            this.companyName = payload.companyName;
            this.companyLogoImage = resolveAssetPath(payload.companyImagePath);
            this.companyLocale = payload.companyLocale;
            this.companyContent = payload.companyContents;

            /* 제품 */

            items.forEach((item) => {
              item.itemImagePath = [];
              item.itemContentInfo = [];
              item.itemContentScope = [];
              item.itemContentNetworkScope = [];
              //탭이름 세팅
              const itemName = item.itemName ? item.itemName : "";
              this.tabs.push(itemName);
              //제품 이미지 세팅
              if (item.itemImages && item.itemImages.length > 0) {
                item.itemImagePath.push(resolveAssetPath(item.itemImages[0].path));
              }
              //제품 콘텐츠 세팅
              if (item.itemContents && item.itemContents.length > 0) {
                item.itemContents.forEach((contents) => {
                  if (contents.type === "info")
                    item.itemContentInfo.push(contents);
                  if (contents.type === "scope")
                    item.itemContentScope.push(contents);
                  if (contents.type === "network_scope")
                    item.itemContentNetworkScope.push(contents);
                });
              }
            });
            //기본 탭 지정
            if (items && items.length > 0) {
              this.companyItems = items;
              this.setActiveTab(this.companyItems[0]?.itemSeq);
            }
          }
        })
        .catch((error) => {
          if (error.response) {
            // 요청은 성공했지만 서버가 2xx 이외의 상태 코드로 응답한 경우.
            console.log("서버 응답 상태 코드:", error.response.status);
            console.log("응답 데이터:", error.response.data); // 응답 데이터에서 오류 세부 정보 확인
          } else if (error.request) {
            // 요청은 성공했지만 응답을 받지 못한 경우.
            console.log("서버로부터 응답을 받지 못했습니다.");
          } else {
            // 요청 설정 중 오류가 발생한 경우.
            console.log("오류:", error.message);
          }
        });
    },
  },

  mounted() {},
  created() {
    this.getProdictInfo();
  },
});
</script>

<style></style>
